module.exports = __webpack_public_path__ + "static/media/hair-dryer.c027ce51.svg";